export default __webpack_public_path__ + "static/logo-big-light-5bf3a864923f848a9a5fc9e24b8dabd1.png";